// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"styles-module__cursorPointer___35jSy"};